import util from '../../common/util';
import global from '../../common/global';
import { mapState as rootMapState, mapActions as rootMapActions } from 'pinia';
import { usePageStore, useUserStore } from '@/store';
import signLog from '../../components/sign-log';
import menuItem from './HeaderMenuItem.vue';
import HideSubdomain from '../../../../cms/src/util/hideSubdomain';
import overlapMixin from './overlap';
import translatorMixin from './translator';
import CurrencyMixin from './currency';
import closelyAppDownload from '../../components/download-closely';
import { asyncData } from './asyncData';
import { mapAsyncData } from '@/plugins/asyncData';
import { getRegistrationOptions } from '../../common/autopopup';
import { getOrganizationSchemaInfo } from '@/common/schemaInfo.js';
// import addSchemaObject from '@/common/util/util-schema-org.js'
export default {
    mixins: [overlapMixin, translatorMixin, CurrencyMixin],
    i18next: {
        ns: 'md-header',
    },
    asyncData: mapAsyncData(asyncData),
    data: function() {
        let config = {
            secBgColor: '', //  Secondary menu background color 
            secTextColor: '', //  Secondary menu text color 
            hoverTextColor: '', //  menu hover s color ( all menus )
            showPhone: true,
            showEmail: true,
            showSocial: true,
            scrollTop: 0,
            headerHeight: 0,
            bgColor: '', // header background color
            overlap: false, // Whether it overlaps with the module below, three and four sets of headers are overlap true on the home page, overlap false on other pages, and overlap false on the first and second sets of headers
            mainMenuText: {
                fontFamily: '',
                fontSize: '',
                color: ''
            }, // Navigation bar first-level menu text style
            sticky: false, // Whether ceiling
            size: 100, //logo size
            logo: '', //logo url
            link: '/', //logo link
            altText: '', //logo altext
            subLogo: '',
            subLogoLink: '/',
            subLogoSize: 100,
            subAltText: '',
            agentId: 0
        };
        return {
            ...config,
            pageClass: '',
            outMoreMenus: [],
            moreMenus: [],
            moreShow: false,
            navStyle: {},
            sideMenuShow: false,
            showHeader: true,
            moreStyle: {},
            theme: '',
            navTop: false,
            mobileLogoFont: {
                default: 30,
                current: 30
            },
            showMobileLangMenu: false,
            showMobileCurrencyMenu: false,
            menus: [] // Raw menu data (passed from config)
        };
    },
    watch: {
        mainMenuText: {
            deep: true,
            handler() {
                this.headerResize();
            }
        },
        sideMenuShow(value) {
            this.handleShowSideMenu(value);
            this.setScrollStatus(value);
            this.headerHeight = this.$refs?.nav?.clientHeight
        },
        showMobileLangMenu(value) {
            this.handleShowSideMenu(value);
        },
        showMobileCurrencyMenu(value) {
            this.handleShowSideMenu(value);
        },
        filteredMenus() {
            this.sizeChange();
        },
        size() {
            this.sizeChange();
            this.mobileImgFontSizeRecalc();
        },
        subLogoSize() {
            this.sizeChange();
            this.mobileImgFontSizeRecalc();
        },
        agentId(value) {
            if (util.inCms) {
                this.getAgentInfo(value);
            }
        }
    },
    computed: {
        // Reactive menus: dynamically filter based on login status
        filteredMenus() {
            let menus = this.menus || [];
            return menus.filter(item => this.hasPage(item));
        },
        showCloseIcon() {
            return (
                this.isMobileSize && (this.sideMenuShow ||
                    this.showMobileLangMenu ||
                    this.showMobileCurrencyMenu)
            );
        },
        defaultLogoAlt() {
            return this.company.name;
        },
        defaultSublogoAlt() {
            return this.company.name;
        },
        seoSchema({ global }) {
            if (global.pageKey !== 'home') {
                return null;
            }

            // CHIME-63234: Organization Schema with nested RealEstateAgent as member
            // Organization contains the company info, with RealEstateAgent as a member
            return getOrganizationSchemaInfo(
                this.company,
                global.agentCreator,
                {
                    location: this.pageLocation,
                    logo: this.logo || this.subLogo,
                    socialLinks: this.socialNetworksInfo
                }
            );
        },
        isDetail({ global }) {
            const pageKey = global.pageKey;
            return ['listing-detail', 'listing-detail-sold'].includes(pageKey);
        },
        adaptiveLogoStyle() {
            if (this.mobileLogoFont.current) {
                return {
                    '--header-logo-fontsize': this.mobileLogoFont.current + 'px'
                };
            }
        },
        ...rootMapState(useUserStore, {
            user: store => store.user,
            userBackgroundColor: store => store.userBackgroundColor
        }),
        ...rootMapState(usePageStore, {
            global: store => (store.page || {}),
            siteId: store => store.page.siteId,
            agents: store => store.agents,
            company: store => (store.companyInfo || { name: '' }),
        }),
        isReallyUser() {
            return this.platform.isReallyUser;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        isLarger({ isMobileSize }) {
            return !isMobileSize;
        },
        isSubSite({ global }) {
            return global.siteType == 3;
        },
        initialFirstName() {
            return this.user?.firstName?.charAt(0);
        },
        mainText() {
            let res = {
                color: this.mainMenuText.color,
                '--header-hovercolor': this.hoverTextColor,
                '--header-bgcolor': this.bgColor,
                '--header-sec-txtcolor': this.secTextColor,
                '--header-sec-bgcolor': this.secBgColor
                // '--header-fontsize': this.mainMenuText.fontSize,
                // '--header-sec-fontsize': this.mainMenuText.fontSize && ((parseInt(this.mainMenuText.fontSize)-2) + 'px')
            };
            if (!this.isMobileSize) {
                let { fontFamily, fontSize } = this.mainMenuText;
                Object.assign(res, {
                    fontFamily,
                    fontSize
                });
                return res;
            }
            Object.assign(res, this.navStyle);
            return res;
        },
        lpAgentHeader({ global }) {
            return global.isLandingPage ? '' : ',module:"header"';
        },
        overlapSize() {
            //use logo not check this.logo
            return (
                Math.max(this.size, this.subLogo ? this.subLogoSize : 0) / 100
            );
        },
        agent_id({ agentId }) {
            return agentId || 0;
        },
        agent({ agents, agent_id }) {
            return agents[agent_id];
        },
        socialNetworksInfo({ agent }) {
            const socialNetworksInfo =
                (agent && agent.agentSocialNetworks) || [];
            return socialNetworksInfo.filter(item => {
                item.icon = 'icon-' + item.socialNetwork;
                if (item.socialNetwork === 'facebook') {
                    item.icon = 'icon-facebook-sign';
                }
                if (item.socialNetwork === 'google+') {
                    item.icon = 'icon-google1';
                }
                if (item.socialNetwork === 'twitter') {
                    item.icon = 'icon-newnewtwitter';
                }
                if (item.socialNetwork === 'tiktok') {
                    item.icon = 'icon-tik-tok';
                }
                return !!item.socialNetwork && !!item.url;
            });
        }
    },
    created() {
        this.menus = this.menus || [];
        this.isSubSite && new HideSubdomain('', util.isSSRServer).applySetting(this.menus);
        uniqueMenus(this.menus);
        this.outMoreMenus = this.filteredMenus;
        this.$EventBus.$on('chatWindowOpen', () => this.getScrollTop());
    },
    mounted() {
        if (this.isDetail) {
            this.sticky = false; //  Due to ceiling conflict ， cancel all first header  Ceiling configuration
        }
        this.mobileImgFontSizeRecalc();
        if (!this.isMobileSize) {
            global.resize(this.headerResize);
        }
        this.isMounted = true;
        this.onLngNsLoaded('md-header').then(() => {
            this.$nextTick(() => {
                this.sizeChange();
            });
        })
        if (
            this.isMobileSize &&
            ['fashion', 'template6', 'template7'].includes(this.theme)
        ) {
            const domClass = ['fashion'].includes(this.theme)
                ? '.nav-container .head-menu'
                : '.nav-container';
            this.disableScroll(
                document.querySelector('.md-header'),
                document.querySelector(domClass)
            );
        }
        this.$nextTick(() => {
            this.syncHeaderHeightToRoot();
        })
    },
    provide() {
        return {
            hideMenu: this.hideMenu
        };
    },
    methods: {
        ...rootMapActions(useUserStore, {
            logoutAction: 'logout'
        }),
        ...rootMapActions(usePageStore, {
            getAgentInfo: 'getAgentInfo'
        }),
        mobileImgFontSizeRecalc() {
            if (!this.isMobileSize || !this.$el || !(this.size + this.subLogoSize)) {
                return;
            }
            let leftWidth =
                    this.$el.querySelector('.header-container').offsetWidth -
                    105, //-margin-padding-moreWidth
                imgs = this.$el.querySelectorAll('.logo img');
            let hasAdaptSmaller =
                this.mobileLogoFont.current &&
                this.mobileLogoFont.current < this.mobileLogoFont.default;
            let currentLogoNotOver = // when first loaded ， picture at the beginning offsetWidth May not be displayed as it should be
                ((imgs[0] && imgs[0].offsetWidth) || 0) +
                    ((imgs[1] && imgs[1].offsetWidth) || 0) <
                leftWidth;
            if (currentLogoNotOver && !hasAdaptSmaller) {
                return;
            }

            let biggerSize = Math.max(this.size, this.subLogoSize);
            let rec =
                imgs[0] && imgs[0].naturalHeight
                    ? ((imgs[0].naturalWidth / imgs[0].naturalHeight) *
                          this.size) /
                      biggerSize
                    : 0;
            rec +=
                imgs[1] && imgs[1].naturalHeight
                    ? ((imgs[1].naturalWidth / imgs[1].naturalHeight) *
                          this.subLogoSize) /
                      biggerSize
                    : 0;
            if (!rec) {
                return;
            }
            let fineFontSize = (leftWidth / rec / biggerSize) * 100;
            fineFontSize = Math.floor(fineFontSize);
            if (fineFontSize > this.mobileLogoFont.default) {
                return;
            } //cannot be bigger
            this.mobileLogoFont.current = Math.floor(fineFontSize);
        },
        hasPage(menu) {
            if (menu.name.length > 53) {
                menu.name = menu.name.slice(0, 50) + '...';
            }
               
            // Specific menu (e.g. owner) requires login to display
            if (menu.link?.toLowerCase().trim() === '/owner') {
                if (!this.user) {
                    return false;
                }
            }
            
            // 1: 所有端展示 ， 2 : 仅在 pc 端展示 ， 3 : 仅在 移动端 和 ipad 端展示
            if (
                !(
                    menu.visible == 1 ||
                    (this.isMobileSize && menu.visible == 3) ||
                    (!this.isMobileSize && menu.visible == 2)
                )
            ) {
                return false;
            }
               
            if (menu.items) {
                menu.items = menu.items.filter(item => {
                    return this.hasPage(item);
                });
                return menu.items.length > 0;
            } else {
                return true;
            }
        },
        headerResize() {
            this.sizeChange();
        },

        async sizeChange() {
            const excludeThemes = ['layout1']
            if (!this.isMounted || excludeThemes.includes(this.theme)) {
                return;
            }
            // this.isLarger = window.innerWidth >= 1000 ; 
            // 爬虫参数全部展示出来
            if (!this.isMobileSize && !this.platform.isBot) {
                const time = new Date().getTime();
                this.time = time;
                this.moreShow = true;
                this.outMoreMenus = this.filteredMenus;
                this.moreMenus = [];
                const boxNumber = (style, cssAttr) => {
                    return Math.ceil(parseFloat(style[cssAttr])) || 0;
                };
                this.$nextTick(() => {
                    if (this.time === time && !util.isSSRServer) {
                        let oHeadInfo = this.$el.querySelector('.head-info'),
                            headInfoWidth = oHeadInfo
                                ? oHeadInfo.offsetWidth
                                : 0;
                        let globalizationDoms =
                            this.$el.querySelectorAll('.head-language-pc');
                        let transWidth = [...globalizationDoms].reduce(
                            (pre, dom) => {
                                return pre + dom.offsetWidth || 0;
                            },
                            0
                        );
                        let navWidth =
                            document.documentElement.clientWidth -
                            this.$el.querySelector('.head-account').offsetWidth -
                            headInfoWidth -
                            transWidth -
                            this.$el.querySelector('.nav-container').offsetLeft;
                        if (this.theme == 'layout6') {
                            navWidth -= 102;
                        }
                        const menuItems = this.$el.querySelectorAll(
                            '.head-menu>.menu-item:not(.more)'
                        );
                        const moreEle = this.$el.querySelector(
                            '.head-menu>.menu-item.more'
                        );
                        if (!moreEle) {
                            return; 
                        }
                        const moreStyle = util.getStyle(moreEle);
                        const moreWidth =
                            moreEle.offsetWidth +
                            boxNumber(moreStyle, 'marginLeft') +
                            boxNumber(moreStyle, 'marginRight');
                        let addWidth = 0;
                        let index = 0;
                        for (let i = 0, len = menuItems.length; i < len; i++) {
                            const menuEle = menuItems[i];
                            const menuEleStyle = util.getStyle(menuEle);
                            const menuEleWidth =
                                menuEle.offsetWidth > 0
                                    ? menuEle.offsetWidth +
                                      boxNumber(menuEleStyle, 'marginLeft') +
                                      boxNumber(menuEleStyle, 'marginRight')
                                    : 0;
                            addWidth += menuEleWidth;
                            if (addWidth + moreWidth > navWidth) {
                                index = i;
                                if (i === len - 1 && addWidth <= navWidth) {
                                    index = 0;
                                }
                                break;
                            }
                        }
                        if (index !== 0) {
                            this.outMoreMenus = this.filteredMenus.slice(0, index);
                            this.moreMenus = this.filteredMenus.slice(index);
                        } else {
                            this.moreShow = false;
                        }
                    }
                });
            } else {
                this.outMoreMenus = this.filteredMenus;
                this.moreMenus = [];
                this.wrapperStyle = {};
                this.submenuStyle = {};
                this.moreShow = false;
            }
        },
        register() {
            this.sideMenuShow = false; //  Mobile phone screen ， collapse side navigation
            // document.body.classList.remove('menu-show');
            let option = {
                allowClose: true
            };
            let autopopup = this.global.registration && (this.global.registration.autopopup || {});
            let [, registration] = getRegistrationOptions(this.global.isLandingPage, autopopup);
            if (Object.keys(registration).length) {
                option.role = registration.registerUserType;
            }
            signLog.register(option);
        },
        signIn() {
            this.sideMenuShow = false;
            // document.body.classList.remove('menu-show');
            signLog.login({
                allowClose: true
            });
        },
        logout() {
            this.axiosIns.get('/api-site/logout', { noCache: true }).then(() => {
                if (this.global.wordPressSSR) {
                    let keys = document.cookie.match(/[^ =;]+(?==)/g);
                    if (keys) {
                        for (let i = 0; i < keys.length; i++) {
                            console.log('delete cookie:' + keys[i]);
                            util.removeCookie(keys[i]);
                        }
                    }
                }
                this.logoutAction();
                window.siteAppVm.updateChat(null, true);
                this.sizeChange();
            });
        },
        showMenu() {
            this.sideMenuShow = true;
        },
        hideMenu() {
            this.sideMenuShow = false;
        },
        headAccountClick(event) {
            if (!this.user) {
                this.register();
                event.stopPropagation();
                event.preventDefault();
            }
        },
        calcMoreStyle() {
            if (!this.$refs.wrapper || !this.$refs.nav) {
                return; 
            }
            let maxHeight =
                window.innerHeight -
                this.$refs.nav.getBoundingClientRect().bottom -
                10;
            this.moreStyle = { 'max-height': maxHeight + 'px' };
            let right = this.$refs.wrapper.getBoundingClientRect().right;
            let left = this.$refs.wrapper.getBoundingClientRect().left;
            if (right > window.innerWidth) {
                this.$refs.wrapper.style.left = `calc(-50% - ${
                    right - window.innerWidth + 20
                }px)`;
            }
            if (window.innerWidth - right > left) {
                //CHIME-12779
                this.$refs.moreMenu &&
                    this.$refs.moreMenu.forEach(item => {
                        item.showMoreLeft = false;
                    });
            }
        },
        handleShowSideMenu(value) {
            const navEle = this.$el.querySelector('.nav-container');
            if (!navEle) {
                return;
            }
            var needHide = ['fashion', 'template6', 'layout7'].indexOf(this.theme) === -1;
            if (value) {
                // if (this.theme == 'standard' || this.theme == 'template5') {
                //     document.body.classList.add('menu-show');
                // }
                util.enableScroll(false);
                this.$el.querySelector('.nav-mask') &&
                    this.$el.querySelector('.nav-mask').classList.add('active');
                const headMenuEle = navEle.querySelector('.head-menu');
                if (needHide) {
                    if (this.t) {
                        window.clearTimeout(this.t);
                    }
                    navEle.style.display = 'block';
                }
                if (
                    headMenuEle &&
                    util.getStyle(headMenuEle)['overflow'] === 'auto'
                ) {
                    headMenuEle.scrollTop = 2;
                } else {
                    navEle.scrollTop = 2;
                }
                if (this.navTop) {
                    this.navStyle = {
                        '--header-top':
                            this.$el.querySelector('.header-bg').offsetHeight +
                            'px'
                    };
                }
            } else {
                // document.body.classList.remove('menu-show');
                this.$el.querySelector('.nav-mask') &&
                    this.$el
                        .querySelector('.nav-mask')
                        .classList.remove('active');
                util.enableScroll(true);
                if (needHide) {
                    this.t = window.setTimeout(() => {
                        navEle.style.display = 'none';
                    }, 500);
                }
            }
        },
        showLangMenu() {
            this.closeAllMenu();
            this.$nextTick(() => {
                this.showMobileLangMenu = true;
            })
        },
        hideLangMenu() {
            this.showMobileLangMenu = false;
        },
        closeAllMenu() {
            this.sideMenuShow = false;
            this.showMobileLangMenu = false;
            this.showMobileCurrencyMenu = false;
        },
        showCurrencyMenu() {
            this.closeAllMenu();
            this.showMobileCurrencyMenu = true;
        },
        hideCurrencyMenu() {
            this.showMobileCurrencyMenu = false;
        },
        setScrollStatus(openMenu) {
            if (this.isMobileSize) {
                if (openMenu) {
                    this.getScrollTop();
                }
                const style = openMenu ? 'hidden' : 'auto';
                document.documentElement.style.overflow = style;
            }
        },
        getScrollTop() {
            this.scrollTop = document.documentElement.scrollTop
        },
        disableScroll(container, selectorScrollable) {
            if (!container || !selectorScrollable) {
                return;
            }
            let data = {
                posY: 0,
                maxscroll: 0
            };
            container.ontouchstart = function(event) {
                const e = event.touches?.[0] || event;
                const elTarget = e.target
                if (selectorScrollable.contains(elTarget)) {
                    data.elScroll = selectorScrollable;
                } else {
                    data.elScroll = null;
                    // event.preventDefault();
                    return;
                }
                data.scrollY = selectorScrollable.scrollTop;
                data.posY = e.pageY;
                data.maxscroll =
                    selectorScrollable.scrollHeight -
                    selectorScrollable.clientHeight;
            };
            container.ontouchmove = function(event) {
                const e = event.touches?.[0] || event;
                if (!(data.elScroll && data.maxscroll > 0)) {
                    event.preventDefault();
                    return;
                }
                const scrollTop = data.elScroll.scrollTop;
                // distanceY > 0 scroll down, otherwise scroll up
                const distanceY = e.pageY - data.posY;
                if (distanceY > 0 && scrollTop == 0) {
                    event.preventDefault();
                    return;
                }
                if (distanceY < 0 && scrollTop + 1 >= data.maxscroll) {
                    event.preventDefault();
                    return;
                }
            };
            container.ontouchend = function() {
                data.maxscroll = 0;
            };
        },
        syncHeaderHeightToRoot() {
            if (util.isSSRServer) {
                return;
            }
            const height = this.getHeaderHeight();
            // set header actually height
            const root = document.documentElement;
            root.style.setProperty('--page-header-height-offset', height + 'px');
        },
        getHeaderHeight() {
            if (util.isSSRServer) {
                return 0;
            }
            const el = this.$el;
            const elHeight = el.offsetHeight;

            // 如果父元素本身有高度，直接返回
            if (elHeight > 0) {
                return elHeight;
            }

            // 否则查找 fixed/absolute 定位的直接子元素
            const children = el.children;
            for (let i = 0; i < children.length; i++) {
                const child = children[i];
                const position = getComputedStyle(child).position;
                if (position === 'fixed' || position === 'absolute') {
                    return child.offsetHeight;
                }
            }

            return 0;
        },
    },
    unmounted() {
        this.isMounted = false;
        global.resize(this.headerResize, true);
    },
    components: {
        'menu-item': menuItem,
        closelyAppDownload
    }
};

function uniqueMenus(menus = [], count = 0) {
    for (let i = 0, len = menus.length; i < len; i++) {
        let menu = menus[i],
            items = menu.items;
        if (items) {
            count = uniqueMenus(items, count);
        } else {
            let link = menu.link;
            if (/^(\/listing|\/search)(\?.+)$/.test(link)) {
                menu.link = util.setQueryField({ sitemenuitem: ++count }, link);
            }
        }
    }
    return count;
}
